import { api } from './api';

export interface Comune {
  id: number;
  comune: string;
  provincia: string;
  siglaProvincia: string;
}

/**
 * Search comuni by name (autocomplete)
 */
const searchComuni = async (search: string): Promise<Comune[]> => {
  if (!search || search.length < 2) return [];
  const response = await api.get<Comune[]>('/comuni', {
    params: { search }
  });
  return response.data;
};

/**
 * Get comuni starting with prefix (autocomplete)
 */
const getComuniByPrefix = async (prefix: string): Promise<Comune[]> => {
  if (!prefix || prefix.length < 2) return [];
  const response = await api.get<Comune[]>('/comuni', {
    params: { prefix }
  });
  return response.data;
};

/**
 * Get comuni by provincia
 */
const getComuniByProvincia = async (provincia: string): Promise<Comune[]> => {
  const response = await api.get<Comune[]>('/comuni', {
    params: { provincia }
  });
  return response.data;
};

/**
 * Get comuni by sigla provincia
 */
const getComuniBySigla = async (sigla: string): Promise<Comune[]> => {
  const response = await api.get<Comune[]>('/comuni', {
    params: { sigla }
  });
  return response.data;
};

/**
 * Get all distinct province names
 */
const getProvince = async (): Promise<string[]> => {
  const response = await api.get<string[]>('/comuni/province');
  return response.data;
};

/**
 * Get all distinct province codes (sigle)
 */
const getSigleProvince = async (): Promise<string[]> => {
  const response = await api.get<string[]>('/comuni/sigle');
  return response.data;
};

const comuniService = {
  searchComuni,
  getComuniByPrefix,
  getComuniByProvincia,
  getComuniBySigla,
  getProvince,
  getSigleProvince,
};

export default comuniService;
